import { gql } from '@apollo/client'
import { PlanetLiteFragment } from '@src/graphql/fragment/planet'

export default gql`
  query GetDetachDetail($input: [GetDetachDetailInput]) {
    getDetachDetail(input: $input) {
      inputParam {
        starID
        slotIndex
        planetID
        originalRentalStartTime
        isDetachByStarOwner
      }
      detachDetail {
        detachPlanet {
          ...PlanetLite
        }
        canBeRenew
        currencyCode
        currencyCodeDecimal
        rentalFee
        platformFee
        rentalFeeAfterPlatform
        rentalDuration
        attachTime
        contractEndTime
        penaltyPercent
        rentalTimePercent
        starOwnerRentalFeePercent
        starOwnerRentalFeeAmount
        planetOwnerRefundPercent
        planetOwnerRefundAmount
      }
      err
    }
  }
  ${PlanetLiteFragment}
`
